var Shopify = Shopify || {};
Shopify.money_format = "${{amount_no_decimals}}";
Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);
  
    function defaultOption(opt, def) {
       return (typeof opt == 'undefined' ? def : opt);
    }
  
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');
  
      if (isNaN(number) || number == null) { return 0; }
  
      number = (number/100.0).toFixed(precision);
  
      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';
  
      return dollars + cents;
    }
  
    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
  
    return formatString.replace(placeholderRegex, value);
};

let saving = false;

$('.add2cart .add2cart_inner > a:not(.direct)').on('click', function(e) {
    e.preventDefault();
    console.log('click');
    if (!$(this).closest('.add2cart').hasClass('add2cart--soldout')) {
        if ($(this).closest('.add2cart').hasClass('add2cart--done')) {
            $(this).closest('.add2cart').removeClass('add2cart--done').find('.add2cart_inner > a').html('Add to cart');
        }
        $(this).closest('.add2cart').addClass('add2cart--open');
    }
});

$('.add2cart .size_guide h3').on('click', function(e) {
    e.preventDefault();
    $(this).closest('.size_guide').toggleClass('size_guide--open');
});

$('.add2cart .add2cart_sizes ul li a, .add2cart a.add').on('click', function(e) {
    e.preventDefault();
    console.log('hoppa');
    
    if (!saving && !$(this).hasClass('not_active')) {
        saving          = true;
        $(this).addClass('loading');
        $(this).closest('ul').addClass('loading');

        const that      = $(this).closest('.add2cart');
        const formData = { 'items': [{'id': $(this).data('variantid'), 'quantity': 1 }] };
        
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(formData)
        }).then(response => {
            $.ajax({
                url: window.location.href,
                success: function(res) {
                    $('.header .cart_btn font').html($(res).find('.cart .cart_inner .cart_content').data('items'));
                    that.removeClass('add2cart--open').addClass('add2cart--done').find('.add2cart_inner > a').html('Item added to cart');
                    that.find('.size_guide').removeClass('size_guide--open');
                    $('.cart .cart_inner .cart_content').html($(res).find('.cart .cart_inner .cart_content').html());
                    
                    that.find('ul, a').removeClass('loading');
                    saving = false;
                },
                error: function(e) {
                    console.log('e', e);
                    that.find('ul, a').removeClass('loading');
                    saving = false;
                }
            });
        }).catch((error) => {
            console.error('Error:', error);
            that.find('ul, a').removeClass('loading');
            saving = false;
        });
    }
})